module.exports = __webpack_public_path__ + "static/img/main_point_img08_mobile.e8501267.svg";